import React from 'react';

// CORE COMPONENTS
import Form from 'core/form/Form';

// LOCAL COMPONENTS
import ToggledItems from './ToggledItems';

// VARIABLES

// FORM COMPONENT
const ToggledTable = ({
  flagName,
  label,
  ...props
}) => (
  <ToggledItems
    flagName={flagName}
    label={label}
    {...props}
  >
    <Form.Table {...props} />
  </ToggledItems>
)

export default ToggledTable